import { getQualityRating, QUALITY_RANGES, type SoapCalculations } from "@/data/oilDatabase"

interface QualityMetricsProps {
  calculations: SoapCalculations
  hasOils: boolean
}

interface MetricBarProps {
  label: string
  value: number
  min: number
  max: number
}

function MetricBar({ label, value, min, max }: MetricBarProps) {
  const rating = getQualityRating(value, min, max)
  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-semibold text-gray-700">{label}</span>
        <span className="text-sm font-bold text-gray-900">{value.toFixed(0)}</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className={`h-3 rounded-full transition-all ${rating.color}`}
          style={{ width: `${Math.min(value, 100)}%` }}
        ></div>
      </div>
      <p className="text-xs text-gray-500 mt-1">
        Target: {min}-{max}
      </p>
    </div>
  )
}

export function QualityMetrics({ calculations, hasOils }: QualityMetricsProps) {
  return (
    <div className="bg-white rounded-xl shadow-md p-6 sticky top-24">
        <h2 className="text-lg font-bold text-gray-900 mb-4">Soap Quality Metrics</h2>

        {hasOils ? (
          <div className="space-y-5">
            <MetricBar
              label="Hardness"
              value={calculations.hardness}
              min={QUALITY_RANGES.hardness.min}
              max={QUALITY_RANGES.hardness.max}
            />
            <MetricBar
              label="Cleansing"
              value={calculations.cleansing}
              min={QUALITY_RANGES.cleansing.min}
              max={QUALITY_RANGES.cleansing.max}
            />
            <MetricBar
              label="Conditioning"
              value={calculations.conditioning}
              min={QUALITY_RANGES.conditioning.min}
              max={QUALITY_RANGES.conditioning.max}
            />
            <MetricBar
              label="Bubbly Lather"
              value={calculations.bubbly}
              min={QUALITY_RANGES.bubbly.min}
              max={QUALITY_RANGES.bubbly.max}
            />
            <MetricBar
              label="Creamy Lather"
              value={calculations.creamy}
              min={QUALITY_RANGES.creamy.min}
              max={QUALITY_RANGES.creamy.max}
            />
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <p className="text-sm">Add oils to see quality metrics</p>
          </div>
        )}
    </div>
  )
}
